<template>
    <v-card class="fill-height" fluid>
        <v-toolbar dark color="primary">
            <router-link :to="{ name: 'home' }" tag="v-btn">
                <v-btn icon dark>
                    <v-icon>close</v-icon>
                </v-btn>
            </router-link>
            <v-toolbar-title>Interessado em nosso sistema!</v-toolbar-title>
        </v-toolbar>

        <v-card color="primary">
            <v-card-text primary-title class="white--text">Caso queira fazer parte ou conhecer nosso sistema preencha o formulário abaixo e aguarde nosso contato.</v-card-text>
        </v-card>
        <v-container class="text-center">
            <v-form ref="form" v-model="valid">
                <v-text-field v-model="item.name" :rules="nameRules" label="Nome" required />
                <v-text-field v-model="item.email" :rules="emailRules" label="E-mail" required />
                <v-text-field v-model="item.phone" :rules="telRules" label="Telefone" mask="(##) # ####-####" required />
                <v-btn color="primary" @click="validate" :loading="processing">Salvar</v-btn>
            </v-form>
        </v-container>
    </v-card>
</template>

<script>
import api from "../helpers/api";
export default {
    name: "Register",
    data() {
        return {
            api,
            processing: false,
            valid: true,
            item: {
                name: "",
                email: "",
                phone: "",
            },
            nameRules: [(v) => !!v || "Nome é obrigatório", (v) => (v && v.length >= 10) || "Nome deve conter pelo menos 10 caracteres"],
            emailRules: [(v) => !!v || "E-mail é obrigatório", (v) => /.{1,}@.{2,}\..{2,}/.test(v) || "E-mail inválido"],
            telRules: [
                (v) => !!v || "Telefone é obrigatório",
                (v) => /^(?:\()?[0-9]{2}(?:\))?\s?[0-9]{1}\s?[0-9]{4}(?:-)?[0-9]{4}$/.test(v) || "Telefone inválido Ex.: (00) 91234-1234",
            ],
        };
    },
    methods: {
        validate() {
            if (this.$refs.form.validate()) {
                this.processing = true;
                this.api.post(
                    this.$http,
                    "contact",
                    this.item,
                    (res) => {
                        this.$router.replace({ name: "login" });
                        this.$root.$emit("msgSuccess", res.message ? res.message : "Verifique seu email para concluir o cadastro.");
                        this.processing = false;
                    },
                    (err) => {
                        this.$root.$emit("msgError", err.body.message ? err.body.message : "Não foi possível enviar sua solicitação.");
                        this.processing = false;
                    }
                );
            }
        },
    },
    created() {},
};
</script>